/* Card Guard theme JS — cart dropdown, toast, notify modal, product page, bundle builder */
(function () {
  'use strict';

  /* ── Money ── */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var format = (window.CardGuard && window.CardGuard.moneyFormat) || '${{amount}}';
    return format
      .replace(/\{\{\s*amount\s*\}\}/, Number(value).toLocaleString('en-AU', { minimumFractionDigits: 2 }))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString('en-AU'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  /* ── Toast ── */
  var toastTimer;
  window.showToast = function (msg) {
    var toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2800);
  };

  /* ── Cart dropdown ── */
  var cartOpen = false;

  function cartEls() {
    return {
      dropdown: document.getElementById('cart-dropdown'),
      items: document.getElementById('cart-items'),
      footer: document.getElementById('cart-footer'),
      count: document.getElementById('cart-count'),
      total: document.getElementById('cart-total')
    };
  }

  window.toggleCart = function (e) {
    if (e) e.stopPropagation();
    cartOpen ? window.closeCart() : window.openCartDropdown();
  };

  window.openCartDropdown = function () {
    cartOpen = true;
    var els = cartEls();
    if (els.dropdown) els.dropdown.classList.add('open');
    refreshCart();
  };

  window.closeCart = function () {
    cartOpen = false;
    var els = cartEls();
    if (els.dropdown) els.dropdown.classList.remove('open');
  };

  function emptyCartHtml() {
    return '<div class="cart-empty">' +
      '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" style="color:var(--mid);margin-bottom:0.75rem;"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
      '<p>Your cart is empty</p>' +
      '<a class="cart-shop-btn" href="/#shop" onclick="closeCart()">Browse guards</a>' +
      '</div>';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderCart(cart) {
    var els = cartEls();
    if (!els.items) return;

    if (els.count) {
      if (cart.item_count > 0) {
        els.count.style.display = 'flex';
        els.count.textContent = cart.item_count;
      } else {
        els.count.style.display = 'none';
      }
    }

    if (cart.items.length === 0) {
      els.items.innerHTML = emptyCartHtml();
      if (els.footer) els.footer.style.display = 'none';
      return;
    }

    els.items.innerHTML = cart.items.map(function (item) {
      var sub = item.variant_title && item.variant_title !== 'Default Title' ? escapeHtml(item.variant_title) : '';
      var props = [];
      if (item.properties) {
        for (var k in item.properties) {
          if (item.properties.hasOwnProperty(k) && item.properties[k] && k.charAt(0) !== '_') {
            props.push(escapeHtml(item.properties[k]));
          }
        }
      }
      if (props.length) sub = props.join(', ');
      var qty = item.quantity > 1 ? item.quantity + '× ' : '';
      var img = item.image
        ? '<img src="' + item.image + '&width=72" alt="" loading="lazy" onerror="this.style.display=\'none\'">'
        : '';
      return '<div class="cart-item">' +
        '<div class="cart-item-swatch">' + img + '</div>' +
        '<div class="cart-item-info">' +
          '<div class="cart-item-name">' + qty + escapeHtml(item.product_title) + '</div>' +
          (sub ? '<div class="cart-item-sub">' + sub + '</div>' : '') +
        '</div>' +
        '<div class="cart-item-right">' +
          '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
          '<button class="cart-item-remove" data-line-key="' + item.key + '">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');

    els.items.querySelectorAll('.cart-item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(btn.getAttribute('data-line-key'), 0);
      });
    });

    if (els.total) els.total.textContent = formatMoney(cart.total_price);
    if (els.footer) els.footer.style.display = 'block';
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () { showToast('Something went wrong — try again'); });
  }

  window.cgAddToCart = function (payload, label) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function () {
      showToast((label || 'Item') + ' added to cart');
      window.openCartDropdown();
    }).catch(function (e) {
      showToast((e && e.description) || 'Could not add to cart');
    });
  };

  document.addEventListener('click', function (e) {
    var dropdown = document.getElementById('cart-dropdown');
    var btn = document.querySelector('.nav-cart-btn');
    if (cartOpen && dropdown && !dropdown.contains(e.target) && btn && !btn.contains(e.target)) {
      window.closeCart();
    }
  });

  /* ── Notify modal ── */
  window.openNotifyModal = function () {
    var m = document.getElementById('notify-modal');
    if (!m) return;
    m.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      var input = document.getElementById('notify-email');
      if (input) input.focus();
    }, 300);
  };

  window.closeNotifyModal = function (e) {
    var m = document.getElementById('notify-modal');
    if (!m) return;
    if (e && e.target !== m) return;
    m.classList.remove('open');
    document.body.style.overflow = '';
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var m = document.getElementById('notify-modal');
      if (m) m.classList.remove('open');
      document.body.style.overflow = '';
      window.closeCart();
    }
  });

  /* ── Mobile menu ── */
  window.toggleMobileMenu = function () {
    var menu = document.getElementById('mobile-menu');
    var burger = document.getElementById('nav-burger');
    if (!menu) return;
    var open = menu.classList.toggle('open');
    if (burger) {
      burger.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  };

  window.closeMobileMenu = function () {
    var menu = document.getElementById('mobile-menu');
    var burger = document.getElementById('nav-burger');
    if (menu) menu.classList.remove('open');
    if (burger) { burger.classList.remove('open'); burger.setAttribute('aria-expanded', 'false'); }
  };

  document.addEventListener('click', function (e) {
    var menu = document.getElementById('mobile-menu');
    var burger = document.getElementById('nav-burger');
    if (menu && menu.classList.contains('open') && !menu.contains(e.target) && burger && !burger.contains(e.target)) {
      window.closeMobileMenu();
    }
  });

  /* ── Hero carousel ── */
  function initHeroCarousel(root) {
    var slides = root.querySelectorAll('.hero-slide');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('.hero-dot');
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var current = 0;
    var timer;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('active', idx === current); });
      dots.forEach(function (d, idx) { d.classList.toggle('active', idx === current); });
    }

    function start() {
      clearInterval(timer);
      timer = setInterval(function () { show(current + 1); }, interval);
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        show(parseInt(d.getAttribute('data-slide'), 10));
        start();
      });
    });

    start();
  }

  /* ── Product page (PSA/BGS toggle drives variant + image) ── */
  document.addEventListener('DOMContentLoaded', function () {
    var pp = document.querySelector('[data-product-json]');
    if (pp) initProductPage(pp);
    var bp = document.querySelector('[data-bundle-builder]');
    if (bp) initBundleBuilder(bp);
    var hero = document.querySelector('[data-hero-carousel]');
    if (hero) initHeroCarousel(hero);
  });

  function initProductPage(root) {
    var product;
    try { product = JSON.parse(root.querySelector('[data-product-json-script]').textContent); } catch (e) { return; }
    var toggle = root.querySelector('.pp-case-toggle');
    var addBtn = root.querySelector('.pp-add-btn');
    var priceEl = root.querySelector('.pp-price');
    var img = root.querySelector('.pp-visual > img');
    var thumbs = root.querySelectorAll('.pp-thumb');
    var selectedVariant = product.variants[0];

    function swapMainImage(src) {
      if (!img || !src) return;
      img.style.opacity = '0';
      img.style.transform = 'scale(0.97)';
      setTimeout(function () {
        img.src = src;
        img.style.opacity = '1';
        img.style.transform = 'scale(1)';
      }, 180);
    }

    function setActiveThumbBySrc(src) {
      if (!src) return;
      var base = src.split('?')[0].split('/').pop();
      thumbs.forEach(function (t) {
        t.classList.toggle('active', t.getAttribute('data-src').split('?')[0].split('/').pop() === base);
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        swapMainImage(t.getAttribute('data-src'));
        thumbs.forEach(function (o) { o.classList.remove('active'); });
        t.classList.add('active');
      });
    });

    /* Show only the selected case's photos (untagged photos always show) */
    function filterThumbs(caseLabel) {
      var visible = 0;
      thumbs.forEach(function (t) {
        var c = t.getAttribute('data-case');
        var show = !caseLabel || !c || c === caseLabel;
        t.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (visible === 0) {
        thumbs.forEach(function (t) { t.style.display = ''; });
      }
    }

    function variantForCase(caseLabel) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if ((v.option1 || '').toLowerCase().indexOf(caseLabel.toLowerCase()) !== -1) return v;
      }
      return product.variants[0];
    }

    function selectCase(btn, caseLabel) {
      toggle.querySelectorAll('button').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      filterThumbs(caseLabel);
      selectedVariant = variantForCase(caseLabel);
      if (priceEl) priceEl.textContent = formatMoney(selectedVariant.price);
      if (addBtn) {
        addBtn.disabled = !selectedVariant.available;
        addBtn.textContent = selectedVariant.available ? 'Add to cart' : 'Sold out';
      }
      if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
        swapMainImage(selectedVariant.featured_image.src);
        setActiveThumbBySrc(selectedVariant.featured_image.src);
      }
    }

    if (toggle) {
      toggle.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () { selectCase(btn, btn.getAttribute('data-case')); });
        var v = variantForCase(btn.getAttribute('data-case'));
        if (v && !v.available) {
          btn.classList.add('soldout');
          btn.title = 'Sold out';
        }
      });
      var activeBtn = toggle.querySelector('button.active');
      if (activeBtn) filterThumbs(activeBtn.getAttribute('data-case'));
    }

    if (addBtn) {
      addBtn.disabled = !selectedVariant.available;
      addBtn.textContent = selectedVariant.available ? 'Add to cart' : 'Sold out';
      addBtn.addEventListener('click', function () {
        if (!selectedVariant.available) return;
        window.cgAddToCart({ id: selectedVariant.id, quantity: 1 }, product.title);
      });
    }
  }

  /* ── Bundle builder ── */
  function initBundleBuilder(root) {
    var size = parseInt(root.getAttribute('data-bundle-size'), 10) || 5;
    var variantId = parseInt(root.getAttribute('data-variant-id'), 10);
    var productTitle = root.getAttribute('data-product-title') || 'Bundle';
    var unavailable = (root.getAttribute('data-unavailable') || '').split(',').filter(Boolean);
    var slots = [];
    for (var i = 0; i < size; i++) slots.push({ colour: null, caseType: null });

    function isSoldOut(colour, caseType) {
      return unavailable.indexOf(colour + '|' + caseType) !== -1;
    }
    function colourFullySoldOut(colour) {
      return isSoldOut(colour, 'PSA') && isSoldOut(colour, 'BGS');
    }

    var COLOURS = [
      { key: 'clear', label: 'Clear', bg: 'transparent', cssClass: 'clear-swatch', labelBg: '#1a1a18' },
      { key: 'black', label: 'Black', bg: '#1a1a18', cssClass: '', labelBg: '#444' }
    ];

    var PREVIEW_IMAGES = {
      'clear|PSA': 'https://cdn.shopify.com/s/files/1/0795/9602/8103/files/clear-guard-psa.png?v=1784248271&width=180',
      'clear|BGS': 'https://cdn.shopify.com/s/files/1/0795/9602/8103/files/clear-guard-bgs.png?v=1784248270&width=180',
      'black|PSA': 'https://cdn.shopify.com/s/files/1/0795/9602/8103/files/black-guard-psa.png?v=1784248271&width=180',
      'black|BGS': 'https://cdn.shopify.com/s/files/1/0795/9602/8103/files/black-guard-bgs.png?v=1784248271&width=180'
    };

    var slotsEl = root.querySelector('#bp-slots');
    var progressBar = root.querySelector('#bp-progress-bar');
    var progressLabel = root.querySelector('#bp-progress-label');
    var sumList = root.querySelector('#bp-sum-list');
    var addBtn = root.querySelector('#bp-add-btn');
    var hint = root.querySelector('#bp-hint');

    function colourData(key) {
      for (var i = 0; i < COLOURS.length; i++) if (COLOURS[i].key === key) return COLOURS[i];
      return null;
    }

    function render() {
      slotsEl.innerHTML = '';
      slots.forEach(function (slot, i) {
        var configured = slot.colour && slot.caseType;
        var cd = colourData(slot.colour);
        var div = document.createElement('div');
        div.className = 'bp-slot' + (configured ? ' configured' : '');
        div.innerHTML =
          '<div class="bp-slot-num">' + (i + 1) + '</div>' +
          '<div class="bp-slot-controls">' +
            '<div class="bp-slot-label">Colour</div>' +
            '<div class="bp-colour-picker">' +
              COLOURS.map(function (c) {
                var sel = slot.colour === c.key;
                var dead = colourFullySoldOut(c.key) || (slot.caseType && isSoldOut(c.key, slot.caseType));
                return '<div class="bp-colour-swatch ' + c.cssClass + (sel ? ' selected' : '') + (dead ? ' soldout' : '') + '"' +
                  ' style="background:' + c.bg + ';"' +
                  ' title="' + c.label + (dead ? ' — sold out' : '') + '" data-slot="' + i + '" data-colour="' + c.key + '"></div>';
              }).join('') +
              '<div class="bp-coming-soon-note">' +
                '<div class="bp-coming-soon-dots">' +
                  '<div class="bp-coming-soon-dot" style="background:#c9992e;" title="Gold — coming soon"></div>' +
                  '<div class="bp-coming-soon-dot" style="background:#2563a8;" title="Blue — coming soon"></div>' +
                  '<div class="bp-coming-soon-dot" style="background:#b82020;" title="Red — coming soon"></div>' +
                  '<div class="bp-coming-soon-dot" style="background:#1a7a42;" title="Green — coming soon"></div>' +
                  '<div class="bp-coming-soon-dot" style="background:#d4548f;" title="Pink — coming soon"></div>' +
                '</div>more coming soon</div>' +
            '</div>' +
            '<div class="bp-slot-label" style="margin-top:0.4rem;">Case type</div>' +
            '<div class="bp-case-pills">' +
              ['PSA', 'BGS'].map(function (ct) {
                var dead = slot.colour && isSoldOut(slot.colour, ct);
                return '<button type="button" class="bp-case-pill' + (slot.caseType === ct ? ' active' : '') + (dead ? ' soldout' : '') + '"' +
                  (dead ? ' title="Sold out in this colour"' : '') +
                  ' data-slot="' + i + '" data-case="' + ct + '">' + ct + ' Case' + (dead ? ' — sold out' : '') + '</button>';
              }).join('') +
            '</div>' +
          '</div>' +
          (configured && PREVIEW_IMAGES[slot.colour + '|' + slot.caseType]
            ? '<div class="bp-slot-preview has-img"' + (cd ? ' style="border-color:' + (cd.key === 'black' ? '#1a1a18' : '#c8c5bc') + ';"' : '') + '>' +
                '<img src="' + PREVIEW_IMAGES[slot.colour + '|' + slot.caseType] + '" alt="' + cd.label + ' Guard — ' + slot.caseType + ' Case" loading="lazy">' +
              '</div>'
            : '<div class="bp-slot-preview"' + (cd ? ' style="border-color:' + (cd.key === 'black' ? '#1a1a18' : '#c8c5bc') + ';"' : '') + '>' +
                '<div class="bp-slot-preview-label" style="background:' + (cd ? cd.labelBg : 'var(--mid)') + '">' + (slot.caseType || '—') + '</div>' +
                '<div class="bp-slot-preview-grade" style="color:' + (cd ? 'var(--dark)' : 'var(--mid)') + '">10</div>' +
              '</div>');
        slotsEl.appendChild(div);
      });

      slotsEl.querySelectorAll('.bp-colour-swatch').forEach(function (el) {
        el.addEventListener('click', function () {
          var idx = +el.getAttribute('data-slot');
          var colour = el.getAttribute('data-colour');
          var cd = colourData(colour);
          if (colourFullySoldOut(colour)) {
            showToast(cd.label + ' is sold out');
            return;
          }
          if (slots[idx].caseType && isSoldOut(colour, slots[idx].caseType)) {
            showToast(cd.label + ' — ' + slots[idx].caseType + ' Case is sold out');
            return;
          }
          slots[idx].colour = colour;
          render();
        });
      });
      slotsEl.querySelectorAll('.bp-case-pill').forEach(function (el) {
        el.addEventListener('click', function () {
          var idx = +el.getAttribute('data-slot');
          var ct = el.getAttribute('data-case');
          if (slots[idx].colour && isSoldOut(slots[idx].colour, ct)) {
            showToast(colourData(slots[idx].colour).label + ' — ' + ct + ' Case is sold out');
            return;
          }
          slots[idx].caseType = ct;
          render();
        });
      });

      var configured = slots.filter(function (s) { return s.colour && s.caseType; }).length;
      progressBar.style.width = (configured / size * 100) + '%';
      progressLabel.textContent = configured + ' of ' + size + ' configured';
      addBtn.disabled = configured < size;
      if (hint) hint.textContent = configured < size ? 'Configure all ' + size + ' slots to add to cart' : 'Ready to add to cart!';

      if (configured === 0) {
        sumList.innerHTML = '<li class="empty">Configure your slots to see a summary</li>';
      } else {
        var groups = {};
        slots.forEach(function (s) {
          if (!s.colour || !s.caseType) return;
          var key = s.colour + '|' + s.caseType;
          groups[key] = (groups[key] || 0) + 1;
        });
        sumList.innerHTML = Object.keys(groups).map(function (key) {
          var parts = key.split('|');
          var cd = colourData(parts[0]);
          return '<li>' + groups[key] + '× ' + cd.label + ' — ' + parts[1] + ' Case</li>';
        }).join('');
        var remaining = size - configured;
        if (remaining > 0) sumList.innerHTML += '<li class="empty">' + remaining + ' slot' + (remaining > 1 ? 's' : '') + ' still to configure</li>';
      }
    }

    addBtn.addEventListener('click', function () {
      var properties = {};
      slots.forEach(function (s, i) {
        var cd = colourData(s.colour);
        properties['Guard ' + (i + 1)] = cd.label + ' — ' + s.caseType + ' Case';
      });
      window.cgAddToCart({ id: variantId, quantity: 1, properties: properties }, productTitle);
    });

    render();
  }
})();
